
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { SaveButton } from '@/components/buttons'

export default Vue.extend({
   name: 'UserHistory',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         loading: false,
         history: [],
      }
   },
   mounted() {
      this.loadData()
   },
   methods: {
      async loadData() {
         this.loading = true
         try {
            this.history = await Api.getPartyHistory(this.editingItem.Id)
         } finally {
            this.loading = false
         }
      },
   },
   components: {
      SaveButton,
   },
})
